import React from "react";
import { Text } from "../../";

import styles from "./WeatherCard.module.scss";

const WeatherCard = ( {location} ) =>
{

    return (
        <div className={styles.root}>
            <Text 
                as={"h1"}
                style={{
                    fontSize: 30,
                    margin: 0
                }}
            >
                {location.name}
            </Text>

            <img width={200} height={200} src={`http://openweathermap.org/img/wn/${location.weather[0].icon}@2x.png`}></img>

            <div className={styles.tempContainer}>

                <Text 
                    style={ {
                        color: "#333333",
                        fontSize: 30
                    } }
                    as={"b"}
                    title={"'Feels like' temperature"}
                >
                    {location.main.feels_like}°
                </Text>

                <Text 
                    style={ {
                        color: "#808080",
                        fontSize: 30
                    } }
                    as={"b"}
                    title={"Actual temperature"}
                >
                    {location.main.temp}°
                </Text>

            </div>
        </div>
    )
}

WeatherCard.defaultProps = {};

export default WeatherCard;